import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`feedback/findList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getProvince({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`feedback/getProvince`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`feedback/save`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`feedback/findById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  del({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`feedback/del`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
